define('plugin/location/collection/LocationCollection',['require','lib/collection/FilterableCollection','plugin/location/model/LocationModel'],function (require) {
	
	var FilterableCollection = require('lib/collection/FilterableCollection');
	var LocationModel = require('plugin/location/model/LocationModel');
	
	/**
	 * Locations list collection
	 * 
	 * @class LocationCollection
	 */
	return FilterableCollection.extend({
		
		url: '/ext/location/',
		model: LocationModel
		
	});
	
});
